import React from "react"

interface Props {
  colour: "orange" | "grey"
}

export const Loader = ({ colour }: Props) => (
  <span className={`loader loader-${colour}`} />
)
